// extracted by mini-css-extract-plugin
module.exports = {"CalendarDay":"index-shimmer_CalendarDay__17LKM","placeholderShimmer":"index-shimmer_placeholderShimmer__3Yqg2"};